export default __webpack_public_path__ + "static/media/search.119f1932.jpg";